import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import LocationsFilter from './locations-filter'
import FacilitatorFilter from './facilitator-filter'
import NameFilter from './name-filter'
import DimensionsFilter from './dimensions-filter'
import DateFilter from './date-filter'
import HoursFilter from './hours-filter'
import { get } from 'lodash'
import './filters.scss'

const Column = ({ children }) => (
    <Col
        xs={12}
        sm={6}
        md={4}
        lg={4}
        xl={2}
    >
        {children}
    </Col>
)

const Filters = ({
    value = {},
    onChange = () => {}
}) => {
    return (
        <div className='filters'>

            <Row style={{ paddingTop: '10px'}}>
                <Column>
                    <DateFilter
                        placeholder='Start Date'
                        value={get(value, 'startDate')}
                        onChange={startDate => onChange({ ...value, startDate })}
                    />
                </Column>
                <Column>
                    <DateFilter
                        placeholder='End Date'
                        value={get(value, 'endDate')}
                        onChange={endDate => onChange({ ...value, endDate })}
                    />
                </Column>
                <Column><HoursFilter onChange={onChange} value={value}  /></Column>
                <Column><DimensionsFilter onChange={onChange} value={value} /></Column>
                <Column><FacilitatorFilter onChange={onChange} value={value}  /></Column>
                <Column><LocationsFilter onChange={onChange} value={value} /></Column>
            </Row>
            <Row style={{ paddingTop: '25px'}}>
                <Col><NameFilter onChange={onChange} value={value}  /></Col>
            </Row>
        </div>
    )
}

export default Filters